import AOS from 'aos';
import 'aos/dist/aos.css';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import Navbar from '../../components/Navbar';
import Footer from '../../components/Footer';
import PageHeader from '../../components/PageHeader';
import Sponsor from '../../components/Sponsor';

function SponsorPage() {
  const { t } = useTranslation();
  useEffect(() => {
    AOS.init({ duration: 1000 }); // Optional config
  }, []);
  return (
    <div id="top">
      {/* <Navbar /> */}
      <PageHeader
        title={t('sponsorPage.title')}
        page={t('sponsorPage.page')}
        pageUrl={'sponsor'}
      />
      <div className="page">
      <Sponsor />
      </div>
      <Footer />
    </div>
  );
}

export default SponsorPage;
